import React from 'react'
import CreateProfileForm from './CreateProfileForm'

export default (props) => <CreateProfileForm editMode {...props} />
